import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFiltersDisplay = ({
  value,
  baseFilterFamily,
  strategy
}) => {
  return /*#__PURE__*/_jsx(FiltersDisplay, {
    styling: {
      padding: 'p-left-0 p-bottom-2'
    },
    baseFilterFamily: baseFilterFamily,
    strategy: strategy,
    value: value
  });
};
export default StyledFiltersDisplay;